<template>
    <div :class="device=='pc'?'IndexNavPc bb2':'IndexNavMobile'">
        <!--<img alt="background" src="https://gw.alipayobjects.com/mdn/rms_08e378/afts/img/A*kJM2Q6uPXCAAAAAAAAAAAABkARQnAQ">-->
        <div class="top-title">
            <div class="lg-c">
                <div class="lg-c1">
                    <el-image :src="lg"></el-image>
                </div>
                <div class="lg-c2">
                    <div>易立德数字化智慧平台</div>
                </div>
            </div>
        </div>
        <div class="title-top" style="margin-top: 80px;">
            &nbsp;
        </div>
        <div class="content">
            <el-row class="r" :gutter="50">
                <el-col @click.native="open(item.discription)" class="c" v-for="(item,index) in items" :key="index"
                        :xs="24"
                        :sm="12" :md="8" :lg="4" :xl="4">
                    <el-card class="c-card" shadow="hover" :body-style="{ padding: '0px' }">
                        <div class="c-card-img" :child="'a'+index">
                            <!--<el-image style="padding: 14px;" :src="item.img" class="image"></el-image>-->
                        </div>
                        <div style="padding: 14px; border-top: 1px solid #ccc">
                            <span class="t1">{{item.title}}</span>
                            <div class="t2">
                                <!-- <el-button type="text" class="button">{{item.discription}}</el-button>-->
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import b1 from "../assets/aa1.svg"
    import b2 from "../assets/aa2.png"
    import b3 from "../assets/nldt2.png"
    import b4 from "../assets/aa4.png"
    import kao from "../assets/kao.jpg"
    import lg from "../assets/lg.png"
    import {getDevice} from "../main";
    export default {
        name: 'IndexNav',
        props: {},
        mounted() {
            this.device = getDevice()
        },
        methods: {
            open: function (url) {
                window.open(url)
            }
        },
        data() {
            return {
                device: 'pc',
                lg: lg,
                items: [
                    {
                        img: b1,
                        title: "OA办公",
                        discription: "http://itest.e-lead.cn/oa/index"
                    },
                    {
                        img: b2,
                        title: "易起学",
                        discription: "http://test3.e-lead.cn:8088"
                    },
                    {
                        img: kao,
                        title: "认证考试",
                        discription: "http://itest.e-lead.cn/exam"
                    },
                    {
                        img: b3,
                        title: "能力地图",
                        discription: "http://test1.e-lead.cn:8092"
                    }, {
                        img: b4,
                        title: "企业邮箱",
                        discription: "http://mail.e-lead.cn"
                    },
                ]
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .IndexNavPc {
        width: 100%;
        height: 100%;

        .top-title {
            width: 100%;
            height: 30%;
            overflow: hidden;

            /* background-image: url("../assets/oa2.jpg");*/
            background-position: 50px 20px;
            background-size: 200px;
            background-repeat: no-repeat;
            background-color: #f3faff;

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;

            .lg-c {
                width: 40%;
                z-index: 2;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                margin-top: 12px;

                .lg-c1 {
                    flex: 0 0 126px;

                    img {
                        height: 100%;
                    }
                }

                .lg-c2 {
                    flex: 0 0 auto;
                    color: #1b2d3e;
                    font-size: 45px;
                    margin-left: 13px;
                    font-weight: bold;


                }


            }

            .bg1 {
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }

        .title-top {
            font-weight: lighter;
            color: rgb(49, 70, 89);
            margin: 0 auto;
            margin-bottom: 30px;
            margin-top: 30px;
            font-size: 30px;
            max-width: 1208px;


        }

        .content {
            max-width: 1208px;
            margin: 0 auto;
            margin-top: 12px;

            .c {
                cursor: pointer;
            }

            .c-card {
                margin-bottom: 33px;

                .c-card-img {
                    background: #309bff4d;
                    height: 177px;

                    &[child='a0'] {
                        background: url("../assets/oalogo.png") center center no-repeat;
                        background-size: 70px;;
                    }

                    &[child='a1'] {
                        background: url("../assets/eqx.png") center center no-repeat;
                        background-size: 130px;
                    }

                    &[child='a2'] {
                        background: url("../assets/kao.jpg") center center no-repeat;
                        background-size: 80px;
                    }

                    &[child='a3'] {
                        background: url("../assets/nldt2.png") center center no-repeat;
                        background-size: 144px;
                    }

                    &[child='a4'] {
                        background: url("../assets/email.png") center center no-repeat;
                        background-size: 80px;
                    }


                    & {
                        background-size: contain;
                        background-position: center;

                    }
                }

                /deep/ .el-card__body {
                    div:nth-child(2) {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;


                        .t1 {
                            color: #0d1a26;
                            font-size: 16px;
                            text-align: center;

                        }

                        .t2 {

                            font-size: 14px;
                        }
                    }

                }


            }

        }

        @media only screen and (min-width: 1200px) {
            .el-col-lg-4 {
                width: 19.7777%;
            }
        }


    }


    .IndexNavMobile {
        width: 100%;
        height: 100%;

        .top-title {
            width: 100%;
            height: 40%;
            overflow: hidden;
            background: url("../assets/bg1.svg") left top repeat-x;
            background-size: cover;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;

            .lg-c {
                width: 100vw;
                z-index: 2;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .lg-c1 {


                    /deep/ img {
                        width: 50vw;
                    }

                    order: 2;
                }

                .lg-c2 {

                    color: #1b2d3e;
                    font-size: 7vw;
                    margin-left: 13px;
                    font-weight: bold;
                    margin-bottom: 4vw;
                    order: 1;
                }


            }

            .bg1 {
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }

        .title-top {
            font-weight: lighter;
            color: rgb(49, 70, 89);
            margin: 0 auto;
            margin-bottom: 7vw;
            margin-top: 7vw;
            font-size: 7vw;
            width: 100%;
            text-align: center;


        }

        .content {
            max-width: 100%;
            margin: 0 auto;
            padding: 4vw;


            .c-card {
                margin-bottom: 7vw;

                .c-card-img {
                    background: #309bff4d;

                }

                .t1 {
                    color: #0d1a26;
                    font-size: 7vw;
                }

                .t2 {

                    font-size: 7vw;
                }
            }

        }


    }
</style>
